"use strict";

define('evisions/drop',['jquery', 'jquery.hammer'], function ($, hammer) {
  var EVIDrop = function EVIDrop(drag, selector) {
    var that = this;
    this.drag = drag;
    this.selector = selector;
    this._callbacks = {
      init: $.Callbacks(),
      enter: $.Callbacks(),
      exit: $.Callbacks(),
      drop: $.Callbacks(),
      move: $.Callbacks(),
      end: $.Callbacks()
    };
    this.init(function () {
      this.setupDrop();
    }).enter(function (el) {
      this.setCurrentlyHovered(el);
    }).exit(function (el) {
      this.setCurrentlyHovered(null);
    }).end(function () {
      this.teardownDrop();
    });
    this.drag.init(function () {
      that._callbacks.init.fire.apply(that, arguments);
    }).end(function () {
      that.handleDragEnd.apply(that, arguments);
    }).move(function () {
      that.handleDragMove.apply(that, arguments);
    });
  };
  EVIDrop.prototype = {
    init: function init(fn) {
      this._callbacks.init.add(fn);
      return this;
    },
    enter: function enter(fn) {
      this._callbacks.enter.add(fn);
      return this;
    },
    exit: function exit(fn) {
      this._callbacks.exit.add(fn);
      return this;
    },
    drop: function drop(fn) {
      this._callbacks.drop.add(fn);
      return this;
    },
    move: function move(fn) {
      this._callbacks.move.add(fn);
      return this;
    },
    end: function end(fn) {
      this._callbacks.end.add(fn);
      return this;
    },
    trigger: function trigger(name) {
      var args = [].concat.apply([], arguments).slice(1);
      if (this._callbacks[name]) {
        this._callbacks[name].fire.apply(this, args);
      }
      return this;
    },
    plugin: function plugin(_plugin) {
      _plugin = _plugin || {};
      var init = _plugin.init,
        enter = _plugin.enter,
        exit = _plugin.exit,
        end = _plugin.end;
      if (init) {
        this.init(init);
      }
      if (enter) {
        this.enter(enter);
      }
      if (exit) {
        this.exit(exit);
      }
      if (end) {
        this.end(end);
      }
      return this;
    },
    setCurrentlyHovered: function setCurrentlyHovered(el) {
      if (el) {
        this.currentlyHovered = $(el);
      } else {
        this.currentlyHovered = null;
      }
    },
    getCurrentlyHovered: function getCurrentlyHovered() {
      return this.currentlyHovered;
    },
    getCurrentlyDragged: function getCurrentlyDragged() {
      return this.drag.getCurrentlyDragged();
    },
    isDragging: function isDragging() {
      return !!this.drag._dragging;
    },
    setupDrop: function setupDrop() {
      this._dropPointer = null;
      this._dropstack = [];
      this.calculateBounds();
    },
    dropzonesMoved: function dropzonesMoved() {
      this.calculateBounds();
    },
    calculateBounds: function calculateBounds() {
      var dropzones = this.drag.$el.find(this.selector),
        i = 0,
        len = dropzones.length,
        bounds = [],
        el = null,
        offset = null;
      for (i = 0; i < len; ++i) {
        el = dropzones.eq(i);
        offset = el.offset();
        bounds.push({
          element: el.get(0),
          top: offset.top,
          left: offset.left,
          right: offset.left + el.outerWidth(),
          bottom: offset.top + el.outerHeight()
        });
      }
      this._dropBounds = bounds;
    },
    teardownDrop: function teardownDrop() {
      this._dropPointer = null;
      this._dropstack = null;
      this._dropBounds = null;
    },
    boundsCheck: function boundsCheck(pos, bounds) {
      var that = this;
      if (pos.x >= bounds.left && pos.x < bounds.right && pos.y >= bounds.top && pos.y < bounds.bottom) {
        if (!bounds.element._entered) {
          bounds.element._entered = true;
          this._boundscheckStackAdded++;
          this._boundsCheckStack.add(function () {
            that.handleMouseEnter({
              currentTarget: bounds.element,
              bounds: bounds
            });
          });
        }
      } else {
        if (bounds.element._entered) {
          bounds.element._entered = false;
          this._boundscheckStackRemoved++;
          that.handleMouseLeave({
            currentTarget: bounds.element,
            bounds: bounds
          });
        }
      }
    },
    handleMouseEnter: function handleMouseEnter(ev) {
      var last = this._dropstack[this._dropstack.length - 1],
        doEnter;
      doEnter = function () {
        this._dropPointer = this._dropstack.length;
        this._dropstack.push(ev.currentTarget);
        if (last) {
          last = $(last);
          this.trigger('exit', last, ev);
        }
        this.trigger('enter', $(ev.currentTarget), ev);
        clearTimeout(this._mouseEnterTimeout);
      }.proxy(this);
      if (this._dropPointer == null) {
        doEnter();
      } else {
        if ($.contains(ev.currentTarget, this._dropstack[this._dropPointer])) {
          this._dropstack.splice(this._dropPointer, 0, ev.currentTarget);
        } else {
          doEnter();
        }
      }
    },
    handleMouseLeave: function handleMouseLeave(ev) {
      var last = $(this._dropstack[this._dropstack.length - 2]),
        lastIndex = this._dropstack.length - 2,
        doEnter;
      doEnter = function () {
        if (this._dropstack.length) {
          ev._nestedDropAction = true;
          this._dropPointer = lastIndex;
          this.trigger('enter', last, ev, true);
        }
      }.proxy(this);
      this.trigger('exit', $(ev.currentTarget), ev);
      this._dropstack.pop();
      if (this._dropPointer == this._dropstack.length) {
        this._dropPointer = this._dropstack.length - 1;
      }
      clearTimeout(this._mouseEnterTimeout);
      this._mouseEnterTimeout = setTimeout(doEnter, 0);
    },
    handleDragEnd: function handleDragEnd(ev, drag) {
      var currentlyHovered = this.currentlyHovered;
      if (this.currentlyHovered && this.currentlyHovered.length) {
        this.trigger('exit', currentlyHovered, ev, drag);
        this.trigger('drop', currentlyHovered, ev, drag);
      }
      this.currentlyHovered = null;
    },
    refireLastDragMove: function refireLastDragMove() {
      if (this._lastDragMoveArgs) {
        this.handleDragMove.apply(this, this._lastDragMoveArgs);
      }
    },
    handleDragMove: function handleDragMove(ev) {
      this._lastDragMoveArgs = arguments;
      var bounds = this._dropBounds,
        cursorPos = {
          x: ev.gesture.center.pageX,
          y: ev.gesture.center.pageY
        },
        i = null;
      this._boundsCheckStack = $.Callbacks();
      for (i = bounds.length - 1; i >= 0; i--) {
        this.boundsCheck(cursorPos, bounds[i]);
      }
      this._boundsCheckStack.fire();
      this._boundsCheckStack = null;
      if (this.currentlyHovered != null) {
        this.trigger('move', cursorPos, this.currentlyHovered);
      }
    }
  };
  return EVIDrop;
});

